import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FiLogIn, FiMail, FiLock, FiUser } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory, useParams } from 'react-router-dom';
// import logo from '../../assets/logo-compressed.png';

import { supportNumber, authTitle, logo, urlWebsite } from '../../config';
import { Container, Content, AnimatedDiv2, ErrorContainer } from './styles';
import Input from '../../components/Forms/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import Whatsapp from '../../components/Whatsapp';
import { useLanguage } from '../../hooks/Language';
import Loader from '../../components/Loader';
import { FaWhatsapp } from 'react-icons/fa';
import Logo from '../../components/Logo';
import { useConfiguration } from '../../hooks/Configuration';
import Axios from 'axios';
import MaskedInput from '../../components/Forms/MaskedInput';



interface SignInData {
  document_number: string;
  password: string;
  name: string;
}

interface IParams {
  redirect?: string;
}

interface IParamsURL {
  projectHash?: string;
  eventHash?: string;
}

const SignIn: React.FC<IParams> = ({ redirect = '/' }) => {
  const history = useHistory();
  const [withPassword, setWithPassword] = useState(false);
  const { signInDocumentNumber } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const { translate } = useLanguage();
  const [errorMessage, setErrorMessage] = useState<Record<string, string>>({});
  const [manutencao, setManutencao] = useState(false);

  const { projectHash, eventHash } = useParams<IParamsURL>();

  const { configuration, setConfiguration } = useConfiguration();

  const verifyPayment = async (email) => {

    try {

      const verify = await Axios.post('https://api-global-v2.encontrodigital.com.br/ecfd73d6-7c83-4648-b116-610380fffea5/check-integration/36-simposio-de-oftalmologia-do-hcpa', { document_number: email });

      return verify;

    }
    catch (err) {
      addToast({ title: err?.response?.data?.message || 'Erro ao identificar integração' });
      return false;
    }


  }

  const handleSubmit = useCallback(
    async (data: SignInData) => {
      setLoading(true);

data.document_number = data.document_number.toString().replace(/[^0-9]/g, '');
      const verify = await verifyPayment(data?.document_number);

      if (!verify) {
        setLoading(false);
        return;
      }

      try {
        formRef.current?.setErrors({});

        const shape = withPassword
          ? {
            document_number: Yup.string()
              .required(`${translate('CPF')} ${translate('obrigatório')}`),
            password: Yup.string().required(`${translate('Senha')} ${translate('obrigatória')}`),
          }
          : {
            document_number: Yup.string()
              .required(`${translate('CPF')} ${translate('obrigatório')}`)

          };

        const schema = Yup.object().shape(shape);
       
        

        await schema.validate(data, { abortEarly: false });

  

        await signInDocumentNumber({ email : data.document_number, password: '', name : '', project_id: configuration?.url, event_id: eventHash ? eventHash : '' });
        window.location.href = `/app/36-simposio-de-oftalmologia-do-hcpa/poster`;
        //  window.location.href = redirect !== '/' ? `/dashboard/${redirect}` : (projectHash ? `/app/${projectHash}/dashboard/` : '/projects');
        return;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          setLoading(false);
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }
        setLoading(false);

        const { status } = err?.response;

        if (status >= 500) {

          setErrorMessage({ title: 'Um momento...', description: 'Estamos com alta demanda de pedidos de acesso. <br/><br/>Por favor refaça seu login em 1 minuto para acessar.' })
          setTimeout(() => {
            setErrorMessage({});
          }, 60000)

        }
        else {

          setErrorMessage({ title: 'Usuário não identificado', description: 'Verifique se há alguma divergência em seus dados.' })
          setTimeout(() => {
            setErrorMessage({});
          }, 5000)

        }




      }
    },
    [signInDocumentNumber, addToast, history],
  );

  return (<>
    {loading && <Loader message="Autenticando seu acesso ..." />}
    <Container>
      <Content>
        <AnimatedDiv2 className='shadowBox'>

          {manutencao ? <div className="onlineMessage ">

            <h2 className="defaultMarked"><div />{translate('Estamos em manutenção')}</h2>
            <p style={{ color: '#333', textAlign: 'center', marginTop: '20px' }}>
              {translate(
                'Voltamos em breve!',
              )}
            </p><br />
          </div> : <Form className="form" ref={formRef} onSubmit={handleSubmit}>


            <h2 style={{ margin: '20px auto' }} className="titleElement">{translate('ACESSAR')}</h2>

            <p style={{ color: '#333', fontSize: '14px', maxWidth: '400px', justifyContent: 'center', margin: '15px auto' }}>Para acessar, é necessário estar inscrito no evento e com pagamento confirmado.</p>

           <MaskedInput
                mask={'999.999.999-99'}
                name="document_number"
                placeholder={'CPF'}
              />
            {withPassword && <Input

              name="password"
              type="password"
              placeholder={translate('Senha')}
            />}

            {errorMessage && errorMessage.title && <ErrorContainer>
              <h2>{errorMessage.title}</h2>
              <p dangerouslySetInnerHTML={{ __html: errorMessage.description }} />
            </ErrorContainer>}
            <aside style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
              <button className='buttonBigGreen' style={{ margin: '0px auto', marginTop: '40px' }} type="submit">{translate('Entrar')}</button>
            </aside>
            {withPassword && <> <p style={{ margin: '10px 0px' }}>Caso tenha dificuldade em logar, solicite uma nova senha.</p>
              <Link style={{ color: '#333' }} to="/recuperar_senha"><Button>{translate('Esqueci minha senha')}</Button>

              </Link></>}


            <aside style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}><Whatsapp
              number={supportNumber}
              text={`${translate(`Olá, estou no ${authTitle}`)}`}
              message={translate('Suporte Técnico')}
            />

            </aside>
          </Form>}
        </AnimatedDiv2>
      </Content>
    </Container></>
  );
};
export default SignIn;
